import PropTypes from 'prop-types';
// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/material';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

import useConfig from 'hooks/useConfig';
import useHeaderTheme from 'hooks/useHeaderTheme';
import { MenuOrientation } from 'config';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // const { headerLogo, headerColor, isLightHeader } = useHeaderTheme();
  const { headerLogo } = useHeaderTheme();

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        // ...(headerColor && {
        //   bgcolor: headerColor,
        //   backgroundImage: isLightHeader ? 'none' : 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.25) 100%)',
        //   boxShadow: isLightHeader ? '0 4px 15px rgba(0, 0, 0, 0.05)' : '0 4px 15px rgba(0, 0, 0, 0.15)',
        //   borderBottom: isLightHeader ? '1px solid rgba(0, 0, 0, 0.05)' : '1px solid rgba(255, 255, 255, 0.1)'
        // }),
        minHeight: isHorizontal ? 'unset' : '60px',
        width: isHorizontal ? { xs: '100%', lg: '100%' } : 'initial',
        position: 'relative',
        zIndex: 1,
        mb: 1
      }}
    >
      {headerLogo ? (
        <Box
          component="img"
          src={headerLogo}
          alt="Logo"
          sx={{
            height: 50,
            width: open ? 'auto' : 50,
            maxWidth: '100%',
            objectFit: 'contain',
            flexShrink: 0,
            filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(255,255,255,0.2))',
            transition: 'all 0.3s ease-in-out'
          }}
        />
      ) : (
        <Logo
          isIcon={!open}
          sx={{
            width: open ? 'auto' : 50,
            height: 50,
            filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3)) drop-shadow(0px 0px 10px rgba(255,255,255,0.2))',
            transition: 'all 0.3s ease-in-out'
          }}
        />
      )}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
